import { API_BASE_URL } from '@synergy/config';
import { FilterParams, SortDirection } from '@synergy/models';
import { PaginatedResponse } from '@synergy/api';
import { createAction } from '@reduxjs/toolkit';

import { AccountListItemDto } from '../models/dto/account-list-item-dto';
import { AppDispatch } from '../../store/store';
import { PoolSnackbar } from '../components/snackbars/pool-snackbar';
import { SupplierApi } from '../api/supplier-api';
import { SupplierDetailDto } from '../models/dto/supplier-detail-dto';
import { SupplierMeta } from '../models/supplier-meta';
import { SupplierSpecialOfferDto } from '../models/dto/supplier-special-offer-dto';
import { enqueueSnackbar } from './snackbar-actions';
import { notFoundError } from './feedback-actions';

const api = new SupplierApi(API_BASE_URL);

export const supplierSpecialOffersReceived = createAction<PaginatedResponse<SupplierSpecialOfferDto>>(
    'supplier/specialOffers-loaded'
);

export const supplierDirectoryReceived =
    createAction<PaginatedResponse<AccountListItemDto, SupplierMeta>>('supplier/directory-loaded');
export const supplierDirectoryReset = createAction('supplier/directory-reset');
export const supplierDetailReceived = createAction<SupplierDetailDto>('supplier/detail-loaded');
export const supplierDetailReset = createAction('supplier/reset');

export const fetchSupplierSpecialOffers = (searchParams?: URLSearchParams) => async (dispatch: AppDispatch) => {
    const response = await api.getSpecialOffers(searchParams);
    if (response.success) {
        dispatch(supplierSpecialOffersReceived(response.result));
    }
    // We don't show an error if failed - just don't display the offers
};

export const fetchSupplierDirectory = (searchParams: URLSearchParams) => async (dispatch: AppDispatch) => {
    // Fixed search params that always need to be in place
    searchParams.set('limit', '50');
    searchParams.set(FilterParams.SortBy, 'name');
    searchParams.set(FilterParams.SortDirection, SortDirection.Ascending);

    const response = await api.getSuppliers(searchParams);
    if (response.success) {
        dispatch(supplierDirectoryReceived(response.result));
    } else {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};

export const fetchSupplierDetail = (id: number) => async (dispatch: AppDispatch) => {
    // Fixed search params that always need to be in place
    const response = await api.getSupplierDetail(id);
    if (response.success) {
        dispatch(supplierDetailReceived(response.result));
    } else {
        dispatch(notFoundError());
    }
};
